/**
 * Canonical roles for organization membership (must match API user_organizations.role).
 */
export const ORGANIZATION_USER_ROLES = Object.freeze(['viewer', 'editor', 'admin']);

export const DEFAULT_ORGANIZATION_USER_ROLE = 'viewer';

export const ORGANIZATION_USER_ROLE_LABELS = Object.freeze({
  viewer: 'Viewer',
  editor: 'Editor',
  admin: 'Admin',
});

/**
 * Coerce stored/legacy role to a valid Select value (viewer | editor | admin).
 */
export function normalizeOrganizationUserRoleForSelect(role) {
  if (role == null || String(role).trim() === '') {
    return DEFAULT_ORGANIZATION_USER_ROLE;
  }
  const r = String(role).trim().toLowerCase();
  if (ORGANIZATION_USER_ROLES.includes(r)) return r;
  if (r === 'member' || r === 'members') return 'viewer';
  if (r === 'administrator' || r === 'owner') return 'admin';
  return DEFAULT_ORGANIZATION_USER_ROLE;
}

/** Display label for a stored role (handles legacy values). */
export function formatOrganizationUserRoleLabel(role) {
  if (role == null || String(role).trim() === '') {
    return ORGANIZATION_USER_ROLE_LABELS.viewer;
  }
  const r = String(role).trim().toLowerCase();
  if (ORGANIZATION_USER_ROLE_LABELS[r]) return ORGANIZATION_USER_ROLE_LABELS[r];
  if (r === 'member' || r === 'members') return ORGANIZATION_USER_ROLE_LABELS.viewer;
  if (r === 'administrator') return ORGANIZATION_USER_ROLE_LABELS.admin;
  if (r === 'owner') return ORGANIZATION_USER_ROLE_LABELS.admin;
  const cap = r.charAt(0).toUpperCase() + r.slice(1);
  return cap;
}
